export default "__VITE_ASSET__DuXylrxv__"